// extracted by mini-css-extract-plugin
export default {"skeleton-brick":"oAUXlN","skeleton-animation":"PRa9FS","skeleton-circle":"Xc_H6N"};